var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccoountIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10,0A5,5,0,1,1,6.464,1.464,5,5,0,0,1,10,0Zm0,2.5a2.5,2.5,0,1,0,1.768.732A2.5,2.5,0,0,0,10,2.5Zm0,8.75c3.337,0,10,1.663,10,5V20H0V16.25C0,12.913,6.662,11.25,10,11.25Zm0,2.375c-3.713,0-7.625,1.825-7.625,2.625v1.375h15.25V16.25C17.625,15.45,13.712,13.625,10,13.625Z",
    fill: "#ad926f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccoountIconActive);
export default __webpack_public_path__ + "static/media/accoountIcon-active.74c233d2ff9e47ab7a0037fd51550c4f.svg";
export { ForwardRef as ReactComponent };